<template>
  <div class="wrapper">
    <div class="wrapper_main">
      <div class="top">
        图层列表
      </div>
      <div class="content">
        <el-form ref="form" :model="selectForm" inline class="formStyle" size="small">
          <el-form-item label="提资方:">
            <el-select v-model="selectForm.carrySpecId" size="small" placeholder="请选择" clearable filterable
              @change="getList(1)">
              <el-option v-for="item in dict.specialty" :key="item.specId" :label="item.specName"
                :value="item.specId" />
            </el-select>
          </el-form-item>
          <el-form-item label="接收方:">
            <el-select v-model="selectForm.receiveSpecId" size="small" placeholder="请选择" clearable filterable
              @change="changeReceiveSpecId">
              <el-option v-for="item in dict.specialty" :key="item.specId" :label="item.specName"
                :value="item.specId" />
            </el-select>
          </el-form-item>
        </el-form>
        <el-table :data="list" border height="500px">
          <template slot="empty">
            <img :src="zanwu" alt="" />
            <p style="font-size: 16px; color: #000; margin-top: 36px">
              请选择提资方和接收方信息
            </p>
          </template>
          <el-table-column type="index" label="序号" width="60px" align="center" />
          <el-table-column label="提资方" align="center" prop="layerType" />
          <el-table-column label="接收方" align="center" prop="receiveSpec" />
          <el-table-column label="图层名" prop="layerName" align="center" />
          <el-table-column label="显示线型" prop="lineType" align="center" />
          <el-table-column label="显示线宽" prop="lineWeight" align="center" />
          <el-table-column label="显示颜色" prop="colour" align="center" />
          <el-table-column label="打印样式" prop="plotStyle" align="center" />
          <el-table-column label="是否关闭" prop="isChoose" align="center" width="80px">
            <template #default="{ row }">
              <el-checkbox v-model="row.isChoose" @change="changeStatus(row.isChoose, row)" />
            </template>
          </el-table-column>
          <el-table-column label="是否冻结" prop="isFrozen" align="center" width="80px">
            <template #default="{ row }">
              <el-checkbox v-model="row.isFrozen" @change="changeStatus(row.isFrozen, row)" />
            </template>
          </el-table-column>
          <el-table-column label="是否锁定" prop="isLocked" align="center" width="80px">
            <template #default="{ row }">
              <el-checkbox v-model="row.isLocked" @change="changeStatus(row.isLocked, row)" />
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="footer">
        <el-pagination v-if="page.totalCount>0" :total="page.totalCount" :current-page="page.pageIndex"
          :page-size="page.pageSize" :page-sizes="[10, 20, 50, 100]" background
          layout="total,sizes, prev, pager, next,jumper" @size-change="handleSizeChange" @current-change="getList" />
      </div>
    </div>
  </div>
</template>
<script>
import standardTemplateService from "@/CommonDP/service/standardTemplate-service";
import collaborationLayerService from "@/CommonDP/service/collaborationLayer-service";
import { getEnterpriseId } from "@/CommonDP/utils/auth";
export default {
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      dict: {
        specialty: []
      },
      list: [],
      page: { pageIndex: 1, pageSize: 20, totalCount: 0 },
      name: "",
      selectForm: {
        carrySpecId: "",
        receiveSpecId: "",
        receiveSpecName: ""
      }
    };
  },
  computed: {
    enterpriseId() {
      return getEnterpriseId("enterpriseId");
    }
  },
  created() {
    this.getDict();
    this.getList(1);
  },
  methods: {
    // 字典
    async getDict() {
      const { data } = await standardTemplateService.getSpecListStandard(this.enterpriseId);
      this.dict.specialty = data;
    },
    // 默认选择
    async changeStatus(status, row) {
      const params = {
        type: 1,
        layerId: row.layerId,
        receiveSpecId: row.receiveSpecId,
        isChoose: row.isChoose ? 1 : 0,
        isFrozen: row.isFrozen ? 1 : 0,
        isLocked: row.isLocked ? 1 : 0
      };
      await collaborationLayerService.updateCollaborationLayerStatus(params);
      if (status) this.$message.success("选择成功");
      else this.$message.success("取消选择");
    },
    // 翻页
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.getList(1);
    },
    // 表格数据
    async getList(pageNo = this.page.pageIndex) {
      const res = await collaborationLayerService.getcollaborationLayerList({
        ...this.selectForm,
        pageNum: pageNo,
        type: 1,
        pageSize: this.page.pageSize,
        enterpriseId: this.enterpriseId
      });
      this.list = res.data;
      this.page.pageIndex = res.pageIndex;
      this.page.totalCount = res.totalCount;
      this.page.pageSize = res.pageSize;
    },
    // 切换接收方
    changeReceiveSpecId(val) {
      if (val) {
        this.selectForm.receiveSpecName = this.dict.specialty.find((ele) => ele.specId === val).specName;
      } else {
        this.selectForm.receiveSpecName = "";
      }
      this.getList(1);
    }
  }
};
</script>
<style lang="scss" scoped>
.wrapper {
  height: 100%;
  background-color: #fff;
  .wrapper_main {
    .top {
      height: 60px;
      line-height: 60px;
      font-weight: 700;
      font-size: 16px;
      color: var(--key-color);
      border-bottom: 1px solid #ebefff;
      padding-left: 20px;
    }

    .content {
      padding: 19px;
      .formStyle {
        /deep/ .el-input__suffix {
          top: -2px;
        }
      }
    }
    .footer {
      text-align: right;
      padding: 19px;
    }
  }
}
</style>
